/**
 *
 * Asynchronously loads the component for UserInterventionPage
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
